import AJS from 'ajs_DO_NOT_USE';
import window from 'window-or-global';
import { getRte } from '../../facades/editor';
import { getContentId } from './commons';
import MacroUtils from './macro-utils';
import { getOverride } from '@confluence/meta';
import { CONTEXT_PATH } from '@confluence-classic/confluence-urls';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

const MacroBrowser = {
	/**
	 * The current selection range in the editor
	 */
	storedRange: null,
	/**
	 * The current bookmark location in the editor
	 */
	bookmark: null,

	getCurrentNode() {
		return $(window.tinymce.activeEditor.selection.getNode());
	},
	isMacroDiv(node) {
		return $(node).hasClass('wysiwyg-macro');
	},
	isMacroTag(node) {
		const $node = $(node);
		return $node.hasClass('wysiwyg-macro') || $node.hasClass('editor-inline-macro');
	},
	isBodylessMacro(node) {
		/** FIXME: This method's name is misleading. */
		return $(node).hasClass('editor-inline-macro');
	},
	isMacroWithBody(node) {
		return $(node).hasClass('wysiwyg-macro');
	},
	isMacroStartTag(node) {
		return $(node).hasClass('wysiwyg-macro-starttag');
	},
	isMacroEndTag(node) {
		return $(node).hasClass('wysiwyg-macro-endtag');
	},
	isMacroBody(node) {
		return $(node).hasClass('wysiwyg-macro-body');
	},
	hasMacroBody(node) {
		return $(node).attr('macrohasbody') == 'true';
	},
	/**
	 * Returns an array of macro names for macro divs enclosing the current node.
	 */
	getNestingMacros(node) {
		const $node = $(node || MacroBrowser.getCurrentNode());
		const nestingMacros = [];
		$node.parents('.wysiwyg-macro').each((i, el) => {
			nestingMacros.push($(el).attr('data-macro-name'));
		});
		return nestingMacros;
	},

	logMCESelection(title) {
		const s = window.tinymce.activeEditor.selection;
		if (process.env.NODE_ENV !== 'production') {
			console.log('******************************');
			console.log(`Logging TinyMCE selection title: ${title}`);
			console.log('Bookmark:');
			console.log(s.getBookmark());
			const rangeNodeText =
				$(s.getRng().startContainer).text() || $(s.getRng().startContainer.parentNode).text();
			console.log(`Range: ${rangeNodeText}`);
			console.log(s.getRng());
		}
	},

	getSelectedMacro() {
		const $selectionNode = MacroBrowser.getCurrentNode();
		if (process.env.NODE_ENV !== 'production') {
			console.log(`getSelectedMacro: $selectionNode=${$selectionNode[0]}`);
		}
		//TODO: MacroUtils
		return MacroBrowser.isMacroDiv($selectionNode)
			? $selectionNode
			: MacroUtils.isInMacro($selectionNode);
	},

	openMacro(macroDefinition) {
		AJS.MacroBrowser.open({
			selectedMacro: macroDefinition,
			onComplete: MacroBrowser.macroBrowserComplete,
			onCancel: MacroBrowser.macroBrowserCancel,
		});
	},

	editMacro(macroNode) {
		const $macroDiv = $(macroNode);
		MacroBrowser.editedMacroDiv = $macroDiv[0];

		/**
		 * serialize() to ensure that any bogus tinymce tags + dirty browser markup are cleaned up.
		 * macro node should be cloned before serialization, as we don't want serialization tampering with the actual DOM element.
		 */
		const macroHtml = window.tinymce.activeEditor.serializer.serialize($macroDiv.clone()[0], {
			forced_root_block: false, // Prevent serialize from wrapping in a <p></p>
		});

		window.tinymce.activeEditor.selection.select($macroDiv[0]);
		getRte().BookmarkManager.storeBookmark();

		$.ajax({
			type: 'POST',
			contentType: 'application/json; charset=utf-8',
			url: `${CONTEXT_PATH}/rest/tinymce/1/macro/definition`,
			data: JSON.stringify({
				contentId: getContentId(),
				macroHtml,
			}),
			dataType: 'text',
			success(macro) {
				MacroBrowser.openMacro(JSON.parse(macro));
			},
		});
	},

	/**
	 * Called to insert a new macro.
	 * If user has not selected text, just open the Macro Browser.
	 * If user has selected text, it will convert it to wiki markup for the body of the macro
	 */
	macroBrowserToolbarButtonClicked(options) {
		const editor = window.tinymce.activeEditor;
		const $node = MacroBrowser.getCurrentNode();
		getRte().BookmarkManager.storeBookmark();

		// Inserting new macro
		const settings = $.extend(
			{
				presetMacroName: null,
				nestingMacros: MacroBrowser.getNestingMacros($node),
				onComplete: MacroBrowser.macroBrowserComplete,
				onCancel: MacroBrowser.macroBrowserCancel,
				mode: 'insert',
				selectedHtml: '',
				selectedText: '',
			},
			options,
		);

		if (options && !options.ignoreEditorSelection) {
			settings.selectedHtml = editor.selection.getContent();
			settings.selectedText = editor.selection.getContent({ format: 'text' });
		}

		if (typeof AJS.MacroBrowser.Model.addMacro !== 'function') {
			return AJS.MacroBrowser.open(settings);
		}

		if (settings.presetMacroMetadata) {
			AJS.MacroBrowser.open(settings);
		} else {
			if (settings.presetMacroName) {
				const macroMetadata = AJS.MacroBrowser.getMacroMetadata(settings.presetMacroName);
				if (!macroMetadata) {
					AJS.MacroBrowser.Rest.fetchMacroMetadataDetails({
						id: settings.presetMacroName,
						successCallback: (data) => {
							function openMacroBrowser() {
								AJS.MacroBrowser.open(settings);
								AJS.unbind('reset.complete', openMacroBrowser);
							}
							if (data && data.details) {
								AJS.MacroBrowser.Model.addMacro(data.details);
								settings.presetMacroMetadata = AJS.MacroBrowser.getMacroMetadata(
									settings.presetMacroName,
								);
								// bind reset callback to open macro browser when reset is complete
								AJS.bind('reset.complete', openMacroBrowser);
								// forceRequire editor resource data (which holds the connect addon information)
								AJS.trigger('reset.rte');
							} else {
								AJS.MacroBrowser.open(settings);
							}
						},
						errorCallback: (err) => {
							console.log('AJS.MacroBrowser.Rest.fetchMacroMetadataDetails ERROR', err);
						},
					});
				} else {
					settings.presetMacroMetadata = macroMetadata;
					AJS.MacroBrowser.open(settings);
				}
			} else {
				AJS.MacroBrowser.open(settings);
			}
		}
	},
	/**
	 * Takes macro markup (usually generated by the Macro Browser) and inserts/updates the relevant Macro macroHeader
	 * in the RTE.
	 * @param macro macro object describing inserted/edited macro
	 */
	macroBrowserComplete(macro) {
		const macroRenderRequest = {
			contentId: getOverride('content-id') || '0',
			macro: {
				name: macro.name,
				params: macro.params,
				defaultParameterValue: macro.defaultParameterValue,
				body: macro.bodyHtml,
			},
		};

		getRte().BookmarkManager.restoreBookmark();

		if (MacroBrowser.editedMacroDiv) {
			MacroUtils.insertMacro(macroRenderRequest, MacroBrowser.editedMacroDiv);
			delete MacroBrowser.editedMacroDiv;
		} else {
			MacroUtils.insertMacro(macroRenderRequest);
		}
	},

	// Called when the macro browser is closed to clean up and reset data.
	macroBrowserCancel() {
		getRte().BookmarkManager.restoreBookmark();
		MacroBrowser.editedMacroDiv = null;
		MacroBrowser.editedMacro = null;
	},
};

export default MacroBrowser;

export function exportMacrobrowserAsGlobal() {
	window.tinymce.confluence = window.tinymce.confluence || {};
	window.tinymce.confluence.macrobrowser = MacroBrowser;
}
